import { isEmpty, isNil } from 'ramda';
import React from 'react';
import { Row, StretchRow } from '../../../styles';
import { ChartData, ChartRange, ChartType } from '../entities';
import { SmallChartSpinner } from '../Spinner';
import Intervals from './Intervals';
import PriceRange from './PriceRange';
import Types from './Types';

interface Props {
  changeRange: (range: ChartRange) => void;
  changeType: (type: ChartType) => void;
  chartData: ChartData[];
  chartRange: ChartRange;
  chartType: ChartType;
  isLoaded: boolean;
}

const Controls = (props: Props) => {
  const { changeRange, changeType, chartData, chartRange, chartType, isLoaded } = props;
  const hasRangeByInterval = !isNil(chartData) || !isEmpty(chartData);

  return (
    <StretchRow>
      <Row>
        <Intervals changeRange={changeRange} range={chartRange} />

        {hasRangeByInterval && <PriceRange data={chartData} />}
        {!isLoaded && <SmallChartSpinner />}
      </Row>

      <Types changeType={changeType} type={chartType} />
    </StretchRow>
  );
};

export default Controls;
